<template>
<div class="logo w-auto">
  <a class="text-xl font-bold font-heading" >
    <router-link :to="{ name: 'home' }">
      <img class="h-12" src="../assets/logo.webp" alt="logo">
    </router-link>
</a>
</div>
</template>

<script>
export default {
    name: 'LogoBox'
}
</script>
